// DES2 WS-14: the Knowledge page copy in this language (see ui/i18n/ns/knowledge-pages.ts).
import type { KnowledgePagesCopy } from '../ns/knowledge-pages';

const el: KnowledgePagesCopy = {
  knowledgePage: 'Σελίδα γνώσης',
  knowledgePages: 'Σελίδες γνώσης',
  featureOffTitle: 'Οι σελίδες γνώσης δεν είναι ενεργοποιημένες σε αυτόν τον χώρο εργασίας.',
  featureOffBody: 'Το πλαίσιο της εταιρείας και οι πηγές εξακολουθούν να βρίσκονται στη Γνώση.',
  loadingPage: 'Φόρτωση σελίδας…',
  loadingSuggestion: 'Φόρτωση πρότασης…',
  cancel: 'Ακύρωση',
  tryAgain: 'Δοκιμάστε ξανά',
  everyoneIn: 'Όλοι στην {company}',
  yourCompany: 'εταιρεία σας',
  revision: 'Αναθεώρηση {n}',
  openRevision: 'Άνοιγμα αναθεώρησης {n}',
  pageCount: 'one:σελίδα|other:σελίδες',
  topicCount: 'one:θέμα|other:θέματα',
  sectionCount: 'one:ενότητα|other:ενότητες',
  lineCount: 'one:γραμμή|other:γραμμές',
  documentCount: 'one:έγγραφο|other:έγγραφα',
  changeCount: 'one:αλλαγή|other:αλλαγές',
  newPageCount: 'one:νέα σελίδα|other:νέες σελίδες',
  changedPageCount: 'one:σελίδα με αλλαγές|other:σελίδες με αλλαγές',
  otherSectionCount: 'one:άλλη ενότητα|other:άλλες ενότητες',
  characterCount: 'one:χαρακτήρας|other:χαρακτήρες',
  diffStats: '{sections} με αλλαγές · προσθήκη: {added} · αφαίρεση: {removed}',
  diffMatchesBase: 'Το προτεινόμενο κείμενο ταυτίζεται με την αναθεώρηση βάσης.',
  diffIntroduction: 'Εισαγωγή',
  diffOtherUnchanged: '{sections} χωρίς αλλαγές.',
  timeJustNow: 'μόλις τώρα',
  originImportedFrom: 'Εισαγωγή από {path}',
  originImportedFromCommit: 'Εισαγωγή από {path} @ {commit}',
  authorityApprovedInPoneva: 'Εγκρίθηκε στο Poneva',
  authorityImported: 'Εισαγόμενη',
  authorityInRepository: '{canonicality} στο αποθετήριο',
  authorityVerified: 'επαληθεύτηκε {date}',
  authorRepositoryImport: 'Εισαγωγή από αποθετήριο',
  authorSuggestedInChat: 'Προτάθηκε στη συνομιλία',
  authorSuggestedInChatWith: 'Προτάθηκε στη συνομιλία με {name}',
  authorSuggestedBy: 'Προτάθηκε από {name}',
  authorSuggestedByApp: 'Προτάθηκε από συνδεδεμένη εφαρμογή',
  authorSuggestedByColleague: 'Προτάθηκε από συνάδελφο',
  authorSuggestedByYou: 'Προτάθηκε από εσάς',
  authorSuggestedOnBehalf: 'Προτάθηκε από {app} εκ μέρους του χρήστη {name}',
  authorSuggestedByAppOnBehalf: 'Προτάθηκε από συνδεδεμένη εφαρμογή εκ μέρους του χρήστη {name}',
  authorSuggestedAndApproved: 'Προτάθηκε και εγκρίθηκε από {name}',
  approverApprovedBy: 'εγκρίθηκε από {name}',
  approverAppliedBy: 'εφαρμόστηκε από {name}',
  kindCreatePage: 'Νέα σελίδα',
  kindUpdatePage: 'Προτεινόμενη ενημέρωση',
  kindArchivePage: 'Αρχειοθέτηση',
  statusConflict: 'Διένεξη · η σελίδα άλλαξε',
  statusPending: 'Σε αναμονή ελέγχου',
  statusApproved: 'Εγκρίθηκε',
  statusRejected: 'Απορρίφθηκε',
  statusWithdrawn: 'Αποσύρθηκε',
  statusSuperseded: 'Αντικαταστάθηκε',
  errRevisionConflict: 'Αυτή η σελίδα άλλαξε ενώ την ελέγχατε.',
  errProposalChanged:
    'Αυτή η πρόταση άλλαξε ενώ την ελέγχατε. Ελέγξτε την πιο πρόσφατη έκδοση πριν αποφασίσετε.',
  errPublishRequired:
    'Μόνο οι υπεύθυνοι δημοσίευσης της εταιρείας μπορούν να εγκρίνουν αλλαγές στη γνώση ή να εισάγουν σελίδες.',
  errProposalLimit:
    'Η εταιρεία σας έχει ήδη 200 προτάσεις σε αναμονή ελέγχου. Ελέγξτε κάποιες πριν προτείνετε περισσότερες.',
  errAuthorLimit:
    'Έχετε ήδη 50 προτάσεις σε αναμονή ελέγχου. Περιμένετε να ληφθεί απόφαση για κάποιες ή αποσύρετε κάποιες πριν προτείνετε περισσότερες.',
  errImportProposalLimit:
    'Αυτή η εισαγωγή θα πρόσθετε περισσότερες σελίδες με αλλαγές για έλεγχο από όσες χωρούν στην ουρά ελέγχου της εταιρείας σας (έως 200). Αποφασίστε για κάποιες προτάσεις στο Για έλεγχο και εφαρμόστε ξανά.',
  errImportChanged:
    'Αυτή η εισαγωγή δεν είναι αυτή που ελέγξατε. Ανοίξτε την ξανά και ελέγξτε την πριν την εφαρμόσετε.',
  errImportItemNotFound: 'Αυτό το έγγραφο δεν αποτελεί πλέον μέρος της εισαγωγής.',
  errIdempotencyConflict:
    'Αυτή η πρόταση έχει ήδη σταλεί με διαφορετικό περιεχόμενο. Φορτώστε ξανά και δοκιμάστε πάλι.',
  errImportHashMismatch:
    'Ένα αρχείο σε αυτό το στιγμιότυπο δεν αντιστοιχεί στο καταγεγραμμένο άθροισμα ελέγχου του. Δημιουργήστε ξανά το στιγμιότυπο και δοκιμάστε πάλι.',
  errImportAlreadyApplied: 'Αυτή η εισαγωγή έχει ήδη εφαρμοστεί.',
  errImportDiscarded: 'Αυτή η εισαγωγή απορρίφθηκε. Επιλέξτε ξανά το αρχείο στιγμιότυπου.',
  errImportDuplicateItem:
    'Αυτό το στιγμιότυπο περιλαμβάνει το ίδιο έγγραφο δύο φορές. Δημιουργήστε ξανά το στιγμιότυπο.',
  errInvalidImport:
    'Το Poneva δεν μπόρεσε να δεχτεί αυτό το στιγμιότυπο. Δημιουργήστε το ξανά με το script στιγμιότυπου και δοκιμάστε πάλι.',
  errInvalidInput:
    'Το Poneva δεν μπόρεσε να δεχτεί αυτά τα δεδομένα. Ελέγξτε τα πεδία και δοκιμάστε ξανά.',
  errImportLimit:
    'Υπάρχουν πάρα πολλές εισαγωγές σε προετοιμασία που δεν έχουν εφαρμοστεί. Εφαρμόστε ή απορρίψτε κάποιες πριν προετοιμάσετε άλλη.',
  errPageTooLarge: 'Μια σελίδα είναι μεγαλύτερη από 256 KB. Χωρίστε τη σε μικρότερες σελίδες.',
  errTooManySections:
    'Μια σελίδα έχει περισσότερες από 2.000 επικεφαλίδες. Χωρίστε τη σε μικρότερες σελίδες.',
  errPageLimit: 'Η εταιρεία σας έχει φτάσει το όριο των 2.000 σελίδων γνώσης.',
  errCollectionLimit: 'Η εταιρεία σας έχει φτάσει το όριο των 100 θεμάτων.',
  errProposalNotPending:
    'Έχει ήδη ληφθεί απόφαση για αυτή την πρόταση. Η κατάσταση που εμφανίζεται είναι η τρέχουσα.',
  errRequesterRemoved:
    'Το άτομο που έκανε αυτή την πρόταση δεν ανήκει πλέον σε αυτή την εταιρεία, οπότε δεν μπορεί να εγκριθεί.',
  errRevisionAlreadyCurrent: 'Αυτή η αναθεώρηση είναι ήδη η τρέχουσα.',
  errPageArchived:
    'Αυτή η σελίδα αρχειοθετήθηκε ενώ την ελέγχατε. Ελέγξτε ξανά την πρόταση πριν αποφασίσετε.',
  errAlreadyArchived: 'Αυτή η σελίδα έχει ήδη αρχειοθετηθεί.',
  errProposalForbidden: 'Μόνο το άτομο που έκανε αυτή την πρόταση μπορεί να την αποσύρει.',
  errUnavailable: 'Οι σελίδες γνώσης δεν είναι διαθέσιμες αυτή τη στιγμή.',
  errTimeout: 'Το Poneva άργησε πολύ να απαντήσει.',
  errItemTooLarge: 'Το {path} είναι μεγαλύτερο από 256 KB. Χωρίστε το σε μικρότερες σελίδες.',
  errItemTooManySections:
    'Το {path} έχει περισσότερες από 2.000 επικεφαλίδες. Χωρίστε το σε μικρότερες σελίδες.',
  errItemHashMismatch:
    'Το {path} δεν αντιστοιχεί στο καταγεγραμμένο άθροισμα ελέγχου του. Δημιουργήστε ξανά το στιγμιότυπο και δοκιμάστε πάλι.',
  errNoLongerAvailable: 'Αυτό το στοιχείο δεν είναι πλέον διαθέσιμο για εσάς.',
  errTooLargeToSend: 'Αυτό το αρχείο είναι πολύ μεγάλο για αποστολή.',
  cardChecking: 'Έλεγχος κατάστασης…',
  cardNotAvailable: 'Μη διαθέσιμο',
  cardStatusUnavailable: 'Η κατάσταση δεν είναι διαθέσιμη',
  cardUnshowable: 'Δεν ήταν δυνατή η εμφάνιση αυτής της προτεινόμενης ενημέρωσης γνώσης.',
  cardEyebrow: 'Προτεινόμενη ενημέρωση γνώσης',
  cardLabel: 'Προτεινόμενη ενημέρωση γνώσης · {title}',
  cardMissing: 'Αυτή η πρόταση δεν είναι πλέον διαθέσιμη για εσάς.',
  cardUnknown:
    'Δεν μπορέσαμε να ελέγξουμε σε ποιο στάδιο βρίσκεται αυτή η πρόταση. Ανοίξτε τον έλεγχο για να δείτε την κατάστασή της.',
  cardCheckAgain: 'Νέος έλεγχος',
  cardReview: 'Έλεγχος ενημέρωσης',
  statusLineApproved: 'Εγκεκριμένη κατανόηση',
  readyCount: 'one:έτοιμο για αναζήτηση|other:έτοιμα για αναζήτηση',
  preparingCount: 'one:σε προετοιμασία|other:σε προετοιμασία',
  attentionCount: 'one:χρειάζεται προσοχή|other:χρειάζονται προσοχή',
  topicsExplore: 'Εξερεύνηση θέματος',
  topicsAllPages: 'Όλες οι σελίδες',
  topicsOpenPages: 'Άνοιγμα Σελίδων',
  topicsEmpty:
    'Δεν υπάρχουν ακόμη εγκεκριμένες σελίδες. Οι σελίδες περιέχουν εκτενή κατανόηση της εταιρείας με πλήρες ιστορικό αναθεωρήσεων.',
  reviewsTitle: 'Προτεινόμενες ενημερώσεις σελίδων',
  reviewsTitleMine: 'Οι προτεινόμενες ενημερώσεις σελίδων σας',
  reviewsIntro:
    'Κάθε πρόταση είναι μια πλήρης υποψήφια αναθεώρηση με την αιτιολογία και τα τεκμήριά της. Τίποτα δεν αλλάζει μέχρι να εγκρίνετε ακριβώς αυτή την αναθεώρηση.',
  reviewsIntroMine:
    'Οι προτάσεις σας περιμένουν εδώ μέχρι να τις ελέγξει ένας υπεύθυνος δημοσίευσης της εταιρείας. Μέχρι τότε οι σελίδες μένουν ως έχουν.',
  loadPagesFailed: 'Δεν μπορέσαμε να φορτώσουμε τις σελίδες γνώσης.',
  loadProposalsFailed: 'Δεν μπορέσαμε να φορτώσουμε τις προτεινόμενες ενημερώσεις σελίδων.',
  loadMoreFailed: 'Δεν μπορέσαμε να φορτώσουμε περισσότερες σελίδες.',
  otherPages: 'Άλλες σελίδες',
  loadTopicFailed: 'Δεν μπορέσαμε να φορτώσουμε αυτό το θέμα.',
  revisionShort: 'α{n}',
  updatedOn: 'Ενημερώθηκε {date}',
  emptyTitle: 'Δεν υπάρχουν ακόμη σελίδες γνώσης.',
  emptyBody:
    'Οι σελίδες περιέχουν την εγκεκριμένη, εκτενή κατανόηση της εταιρείας σας — κατεύθυνση, αποφάσεις και τρόπους εργασίας — και διατηρείται κάθε αναθεώρηση. Κάντε εισαγωγή από στιγμιότυπο αποθετηρίου ή ξεκινήστε μια σελίδα στη συνομιλία· ένας υπεύθυνος δημοσίευσης εγκρίνει κάθε σελίδα πριν μετρήσει ως γνώση της εταιρείας.',
  importFromSnapshot: 'Εισαγωγή από στιγμιότυπο αποθετηρίου',
  startInChat: 'Έναρξη σελίδας στη συνομιλία',
  startInChatPrompt:
    'Βοήθησέ με να ξεκινήσω μια σελίδα γνώσης για την εταιρεία μας. Ρώτα με τι πρέπει να καλύπτει και μην επινοείς περιεχόμενο. Θα παραμείνει πρόταση μέχρι να την εγκρίνει ένας υπεύθυνος δημοσίευσης της εταιρείας.',
  loadingPages: 'Φόρτωση σελίδων γνώσης…',
  filterLabel: 'Φιλτράρισμα σελίδων κατά τίτλο',
  filterPlaceholder: 'Φιλτράρισμα σελίδων',
  importButton: 'Εισαγωγή',
  showingTopic: 'Εμφανίζεται: {topic}',
  showAllTopics: 'Εμφάνιση όλων των θεμάτων',
  loadingTopic: 'Φόρτωση αυτού του θέματος…',
  noMatch: 'Καμία σελίδα δεν ταιριάζει με «{filter}».',
  topicNoPages: 'Δεν υπάρχουν ακόμη εγκεκριμένες σελίδες σε αυτό το θέμα.',
  loading: 'Φόρτωση…',
  loadMore: 'Φόρτωση περισσότερων σελίδων',
  metaApproved: 'εγκρίθηκε {date}',
  metaRepositoryAuthoritative: 'το αποθετήριο παραμένει η έγκυρη πηγή',
  loadPageFailed: 'Δεν μπορέσαμε να φορτώσουμε αυτή τη σελίδα.',
  loadHistoryFailed: 'Δεν μπορέσαμε να φορτώσουμε το ιστορικό αναθεωρήσεων.',
  outlineLabel: 'Ενότητες σελίδας',
  outlineToggle: 'Σε αυτή τη σελίδα',
  loadingHistory: 'Φόρτωση ιστορικού αναθεωρήσεων…',
  historyLabel: 'Ιστορικό αναθεωρήσεων',
  historyIntro:
    'Κάθε εγκεκριμένη αναθεώρηση διατηρείται. Η επαναφορά μιας παλαιότερης δημιουργεί μια πρόταση για έλεγχο· δεν διαγράφει ποτέ μεταγενέστερες αναθεωρήσεις.',
  historyCurrent: 'Τρέχουσα',
  historyViewing: 'Σε προβολή',
  historyView: 'Προβολή',
  historyViewAria: 'Προβολή αναθεώρησης {n}',
  restoreAria: 'Επαναφορά ως πρόταση: αναθεώρηση {n}',
  restoreCreating: 'Δημιουργία πρότασης…',
  restore: 'Επαναφορά ως πρόταση',
  restoreUnconfirmed:
    'Δεν μπορέσαμε να επιβεβαιώσουμε ότι δημιουργήθηκε η πρόταση. Ελέγξτε το Για έλεγχο πριν δοκιμάσετε ξανά.',
  editTooLarge:
    'Αυτή η σελίδα είναι μεγαλύτερη από 256 KB. Χωρίστε τη σε μικρότερες σελίδες πριν την προτείνετε.',
  editConflict:
    'Αυτή η σελίδα άλλαξε ενώ την επεξεργαζόσασταν. Αντιγράψτε το κείμενό σας, ανοίξτε την πιο πρόσφατη αναθεώρηση και προτείνετε ξανά την αλλαγή.',
  editUnconfirmed:
    'Δεν μπορέσαμε να επιβεβαιώσουμε ότι στάλθηκε η πρότασή σας. Ελέγξτε το Για έλεγχο πριν τη στείλετε ξανά.',
  editHeading: 'Πρόταση αλλαγής',
  editIntro:
    'Επεξεργάζεστε την αναθεώρηση {n}. Ένας υπεύθυνος δημοσίευσης της εταιρείας ελέγχει την ακριβή αλλαγή πριν γίνει αναθεώρηση {next}· μέχρι τότε η σελίδα μένει ως έχει.',
  editOutdated:
    'Εγκρίθηκε νεότερη αναθεώρηση ενώ κάνατε επεξεργασία. Αντιγράψτε το κείμενό σας και ξεκινήστε ξανά από την πιο πρόσφατη αναθεώρηση, ώστε να μη χαθεί τίποτα από όσα άλλαξε.',
  editContentLabel: 'Περιεχόμενο σελίδας (Markdown)',
  editReasonLabel: 'Γιατί αυτή η αλλαγή;',
  editReasonPlaceholder: 'Τι άλλαξε και από πού προέρχεται.',
  editSending: 'Αποστολή…',
  editSend: 'Αποστολή για έλεγχο',
  editDiscardConfirm: 'Απόρριψη αυτής της επεξεργασίας; Δεν έχει σταλεί τίποτα από όσα αλλάξατε.',
  editNoChanges: 'Δεν υπάρχουν ακόμη αλλαγές.',
  editNeedsContent: 'Μια σελίδα χρειάζεται κάποιο περιεχόμενο.',
  exportFailed: 'Δεν μπορέσαμε να εξαγάγουμε αυτή τη σελίδα. Δοκιμάστε ξανά.',
  askPagePrompt: 'Ερώτηση για τη σελίδα γνώσης «{title}» (αναθεώρηση {n}, {link}):',
  askPageSectionPrompt:
    'Ερώτηση για τη σελίδα γνώσης «{title}» § {section} (αναθεώρηση {n}, {link}):',
  pageMissingTitle: 'Αυτή η σελίδα δεν είναι διαθέσιμη.',
  pageMissingBody:
    'Ίσως έχει αρχειοθετηθεί ή ίσως δεν έχετε πλέον πρόσβαση στη γνώση αυτής της εταιρείας.',
  pageArchived: 'Αρχειοθετημένη',
  viewingRevisionCurrent: 'Βλέπετε την αναθεώρηση {n}· η τρέχουσα αναθεώρηση είναι η {current}.',
  viewingRevisionOld: 'Βλέπετε την αναθεώρηση {n}. Δεν είναι η τρέχουσα αναθεώρηση.',
  openCurrent: 'Άνοιγμα τρέχουσας',
  archivedBanner:
    'Αυτή η σελίδα είναι αρχειοθετημένη. Δεν τροφοδοτεί πλέον απαντήσεις· το ιστορικό της διατηρείται.',
  pageViewsLabel: 'Προβολές σελίδας',
  tabRead: 'Ανάγνωση',
  tabHistory: 'Ιστορικό',
  unknownSection:
    'Η συνδεδεμένη ενότητα δεν περιλαμβάνεται σε αυτή την αναθεώρηση. Εμφανίζεται ολόκληρη η σελίδα.',
  askAboutPage: 'Ερώτηση για αυτή τη σελίδα',
  exporting: 'Εξαγωγή…',
  exportMarkdown: 'Εξαγωγή σε Markdown',
  loadSuggestionFailed: 'Δεν μπορέσαμε να φορτώσουμε αυτή την πρόταση.',
  evidenceSource: 'Πηγή',
  evidenceFact: 'Πλαίσιο εταιρείας',
  evidenceResult: 'Αποθηκευμένη εργασία',
  evidenceUrl: 'Ιστοσελίδα',
  evidenceDecision: 'Απόφαση',
  evidenceReference: 'Παραπομπή',
  evidenceOpenPage: 'Άνοιγμα σελίδας γνώσης',
  evidenceOpenSource: 'Άνοιγμα πηγής',
  evidenceOpenFact: 'Άνοιγμα πλαισίου εταιρείας',
  evidenceOpenResult: 'Άνοιγμα αποθηκευμένης εργασίας',
  evidenceOpenUrl: 'Άνοιγμα ιστοσελίδας',
  evidenceOpenDecision: 'Άνοιγμα απόφασης',
  evidenceOpenReference: 'Άνοιγμα παραπομπής',
  evidenceDecisionNote: 'Μια καταγεγραμμένη απόφαση. Δεν υπάρχει κάτι για άνοιγμα στο Poneva.',
  evidenceFactGone: 'Αυτό το πλαίσιο εταιρείας δεν είναι πλέον αποθηκευμένο.',
  evidencePageNoRevision: 'Αυτή η σελίδα δεν έχει εγκεκριμένη αναθεώρηση για άνοιγμα.',
  evidencePrivateExcerpt: 'Ιδιωτικό τεκμήριο — κοινοποιήθηκε μόνο το παραπάνω απόσπασμα.',
  evidencePrivate: 'Ιδιωτικό τεκμήριο — το περιεχόμενό του δεν κοινοποιήθηκε σε εσάς.',
  evidenceHeading: 'Τεκμήρια',
  evidenceNone: 'Δεν επισυνάφθηκαν τεκμήρια. Αξιολογήστε την παραπάνω αιτιολογία από μόνη της.',
  changeAdded: 'Προστέθηκε',
  changeRemoved: 'Αφαιρέθηκε',
  changeChanged: 'Άλλαξε',
  changeUnchanged: 'Χωρίς αλλαγές',
  moreLineCount: 'one:ακόμη γραμμή|other:ακόμη γραμμές',
  moreUnchangedLineCount: 'one:ακόμη αμετάβλητη γραμμή|other:ακόμη αμετάβλητες γραμμές',
  unchangedLineCount: 'one:αμετάβλητη γραμμή|other:αμετάβλητες γραμμές',
  skipAdded: '{lines} — δείτε την πλήρη αναθεώρηση',
  skipRemoved: '{lines} που αφαιρούνται',
  cutUnchanged: 'Εκτός προβολής: {lines}',
  cutChanged: 'Εκτός προβολής: {lines}, {changes}. Ελέγξτε τις στην πλήρη αναθεώρηση.',
  cutAddedRemoved: 'προσθήκες: {added}, αφαιρέσεις: {removed}',
  cutAdded: 'προσθήκες: {added}',
  cutRemoved: 'αφαιρέσεις: {removed}',
  lineAddedSr: 'Προστέθηκε:',
  lineRemovedSr: 'Αφαιρέθηκε:',
  noLinesAdded: 'Νέα ενότητα. Το κείμενό της βρίσκεται στην πλήρη αναθεώρηση παρακάτω.',
  noLinesRemoved: 'Αυτή η ενότητα θα αφαιρεθεί από τη σελίδα.',
  noLinesChanged:
    'Αυτή η ενότητα αλλάζει. Το κείμενό της βρίσκεται στην πλήρη αναθεώρηση παρακάτω.',
  diffHeading: 'Αλλαγές',
  outcomeArchived: 'Αρχειοθετήθηκε.',
  outcomeArchivedBody:
    'Η σελίδα {title} δεν τροφοδοτεί πλέον απαντήσεις και αφαιρέθηκε από τη λίστα σελίδων. Οι αναθεωρήσεις της, αυτή η πρόταση και η απόφαση παραμένουν στο ιστορικό της σελίδας.',
  openArchivedPage: 'Άνοιγμα αρχειοθετημένης σελίδας',
  outcomeApproved: 'Εγκρίθηκε.',
  outcomeApprovedRevision: 'Η αναθεώρηση {n} είναι πλέον η εγκεκριμένη έκδοση της σελίδας {title}.',
  outcomeApprovedPlain: 'Αυτή η πρόταση εγκρίθηκε.',
  outcomeRestored: 'Η σελίδα επέστρεψε στη λίστα σελίδων και τροφοδοτεί ξανά απαντήσεις.',
  outcomeKept:
    'Η πρόταση, η απόφαση και κάθε προηγούμενη αναθεώρηση παραμένουν στο ιστορικό της σελίδας.',
  openPage: 'Άνοιγμα σελίδας',
  outcomeDismissed: 'Απορρίφθηκε.',
  outcomeWithdrawn: 'Αποσύρθηκε.',
  outcomeSuperseded: 'Αντικαταστάθηκε.',
  outcomeSupersededBody:
    'Μια νεότερη αναθεώρηση, πρόταση ή εισαγωγή από αποθετήριο κατέστησε αυτή την πρόταση παρωχημένη. Η ίδια δεν άλλαξε τίποτα.',
  outcomeUnchanged: 'Η σελίδα μένει ως έχει.',
  approveNewPage: 'Έγκριση νέας σελίδας',
  approveArchive: 'Έγκριση αρχειοθέτησης',
  approveRestoreRevision: 'Επαναφορά και έγκριση αναθεώρησης {n}',
  approveRevision: 'Έγκριση αναθεώρησης {n}',
  approveArchiveNote: 'Με την έγκριση, αυτή η σελίδα αρχειοθετείται για όλους στην {company}.',
  approvePublishNote: 'Με την έγκριση, αυτή η αναθεώρηση δημοσιεύεται για όλους στην {company}.',
  approvePublishEvidenceNote:
    'Με την έγκριση, αυτή η αναθεώρηση και τα αποσπάσματα τεκμηρίων που εμφανίζονται παραπάνω δημοσιεύονται για όλους στην {company}.',
  archivedTitle: 'Αυτή η σελίδα είναι αρχειοθετημένη.',
  alreadyArchivedBody:
    'Η έγκριση δεν θα άλλαζε τίποτα, οπότε αυτή η πρόταση μπορεί μόνο να απορριφθεί.',
  archivedRestoreBody:
    'Η έγκριση την επαναφέρει: η σελίδα επιστρέφει στη λίστα σελίδων, στην αναζήτηση και στις απαντήσεις με αυτή την αναθεώρηση.',
  staleRevisionAction: 'Σύγκριση με την πιο πρόσφατη έκδοση',
  staleProposalTitle: 'Αυτή η πρόταση άλλαξε ενώ την ελέγχατε.',
  staleProposalAction: 'Έλεγχος της πιο πρόσφατης έκδοσης',
  staleArchivedTitle:
    'Αυτή η σελίδα αρχειοθετήθηκε ενώ την ελέγχατε. Η έγκριση αυτής της πρότασης θα την επανέφερε.',
  staleArchivedAction: 'Νέος έλεγχος',
  suggestionMissingTitle: 'Αυτή η πρόταση δεν είναι διαθέσιμη.',
  suggestionMissingBody:
    'Ίσως έχει αποσυρθεί ή ανήκει σε κάποιον άλλο και δεν έχει σταλεί για έλεγχο από την εταιρεία.',
  decideUnconfirmed:
    'Δεν μπορέσαμε να επιβεβαιώσουμε την απόφασή σας. Η κατάσταση που εμφανίζεται είναι η πιο πρόσφατη από το Poneva· ελέγξτε την πριν δοκιμάσετε ξανά.',
  decideFailed: 'Δεν μπορέσαμε να αποθηκεύσουμε την απόφασή σας.',
  discussPrompt:
    'Βοήθησέ με να βελτιώσω την προτεινόμενη ενημέρωση γνώσης για τη σελίδα «{title}» ({link}).',
  conflictBody:
    'Αυτή η πρόταση γράφτηκε με βάση την αναθεώρηση {base}· η τρέχουσα αναθεώρηση είναι η {current}. Η έγκρισή της θα αντικαθιστούσε εκείνη την αλλαγή, οπότε δεν μπορεί να εγκριθεί ως έχει.',
  conflictBodyPlain:
    'Αυτή η πρόταση γράφτηκε με βάση παλαιότερη αναθεώρηση, οπότε δεν μπορεί να εγκριθεί ως έχει.',
  openLatest: 'Άνοιγμα της πιο πρόσφατης έκδοσης',
  reworkInChat: 'Επανεπεξεργασία στη συνομιλία',
  factReason: 'Αιτιολογία',
  factNoReason: 'Δεν δόθηκε αιτιολογία.',
  factAudience: 'Κοινό',
  factRevision: 'Αναθεώρηση',
  revisionNew: 'Νέα σελίδα, αναθεώρηση 1',
  revisionArchiveAfter: 'Αρχειοθέτηση μετά την αναθεώρηση {n}',
  revisionWrittenAgainst:
    'Γράφτηκε με βάση την αναθεώρηση {base}· η τρέχουσα αναθεώρηση είναι η {current}',
  revisionCurrentToProposed: 'Τρέχουσα αναθεώρηση {base} → προτεινόμενη αναθεώρηση {next}',
  revisionProposed: 'Προτεινόμενη αναθεώρηση {next}',
  proposedPage: 'Προτεινόμενη σελίδα',
  archivingHeading: 'Τι κάνει η αρχειοθέτηση',
  archivingBody:
    'Η σελίδα παύει να τροφοδοτεί απαντήσεις και αφαιρείται από τη λίστα σελίδων. Οι αναθεωρήσεις της και αυτή η απόφαση διατηρούνται.',
  noComparison: 'Δεν υπάρχει διαθέσιμη σύγκριση ενοτήτων για αυτή την πρόταση.',
  showComplete: 'Εμφάνιση πλήρους αναθεώρησης',
  approving: 'Έγκριση…',
  dismissing: 'Απόρριψη…',
  dismiss: 'Απόρριψη',
  withdrawing: 'Απόσυρση…',
  withdraw: 'Απόσυρση',
  editInChat: 'Επεξεργασία στη συνομιλία',
  waitingForPublisher: 'Σε αναμονή μέχρι να την ελέγξει ένας υπεύθυνος δημοσίευσης της εταιρείας.',
  snapshotTooLarge:
    'Αυτό το στιγμιότυπο είναι μεγαλύτερο από 8 MB. Δημιουργήστε το με λιγότερα έγγραφα.',
  snapshotNotSnapshot:
    'Αυτό το αρχείο δεν είναι στιγμιότυπο γνώσης. Επιλέξτε το αρχείο JSON που δημιούργησε το script στιγμιότυπου.',
  snapshotEmpty: 'Αυτό το στιγμιότυπο δεν περιέχει έγγραφα.',
  readDocumentFailed: 'Δεν μπορέσαμε να διαβάσουμε αυτό το έγγραφο. Δοκιμάστε ξανά.',
  readingDocument: 'Ανάγνωση του εγγράφου…',
  hideText: 'Απόκρυψη κειμένου',
  readText: 'Ανάγνωση κειμένου',
  textOf: 'Κείμενο του {title}',
  gitSnapshot: 'Στιγμιότυπο Git {commit}',
  repositorySnapshot: 'Στιγμιότυπο αποθετηρίου',
  importNewHeading: '{pages} · έγκριση κατά την εφαρμογή',
  importNewNote:
    'Καθεμία δημοσιεύεται ως εγκεκριμένη σελίδα για όλους στην {company}, χωρίς περαιτέρω έλεγχο. Διαβάστε καθεμία πριν την εφαρμογή.',
  importChangedHeading: '{pages} · αποστολή για έλεγχο',
  importChangedNote:
    'Καθεμία γίνεται προτεινόμενη ενημέρωση. Η σελίδα της αλλάζει μόνο όταν την εγκρίνει ένας υπεύθυνος δημοσίευσης στο Για έλεγχο, όπου φαίνεται τι άλλαξε.',
  unchangedDocumentCount: 'one:αμετάβλητο έγγραφο|other:αμετάβλητα έγγραφα',
  unchangedNote:
    'Αυτά ταυτίζονται ήδη με τις εγκεκριμένες σελίδες τους. Δεν γράφεται τίποτα για αυτά.',
  stagedHeading: 'Σε προετοιμασία αλλά χωρίς εφαρμογή',
  excludedSummary: '{documents} εκτός αυτού του στιγμιότυπου',
  countsLine: '{newPages} · {changedPages} για έλεγχο · {unchanged} χωρίς αλλαγές',
  importAlreadyDiscarded: 'Αυτή η εισαγωγή έχει ήδη απορριφθεί.',
  confirmLabel: 'Επιβεβαίωση εισαγωγής',
  unchangedKeepCount:
    'one:αμετάβλητο έγγραφο διατηρεί τη σελίδα του|other:αμετάβλητα έγγραφα διατηρούν τις σελίδες τους',
  confirmBody:
    'Εφαρμογή αυτής της εισαγωγής για όλους στην {company}; {newPages}: έγκριση ως αναθεώρηση 1· {changedPages}: αναμονή για έλεγχο· και {unchanged}. Οι προηγούμενες προτάσεις εισαγωγής για αυτές τις σελίδες αποσύρονται.',
  applying: 'Εφαρμογή…',
  applyImport: 'Εφαρμογή εισαγωγής',
  chooseAnother: 'Επιλογή άλλου αρχείου',
  allCurrent: 'Όλα σε αυτό το στιγμιότυπο είναι ήδη ενημερωμένα.',
  importApplied: 'Η εισαγωγή εφαρμόστηκε.',
  appliedSummary:
    'Δημιουργία: {pages} · σε αναμονή ελέγχου: {changes} · χωρίς αλλαγές: {unchanged}.',
  appliedIndexing:
    'Οι νέες σελίδες γίνονται αναζητήσιμες στη συνομιλία μόλις ολοκληρωθεί η ευρετηρίαση. Η Προετοιμασία πηγών δείχνει την πρόοδο.',
  openPages: 'Άνοιγμα σελίδων',
  reviewChanges: 'Έλεγχος: {changes}',
  checkIndexing: 'Έλεγχος προόδου ευρετηρίασης',
  sendSnapshotFailed: 'Δεν μπορέσαμε να στείλουμε αυτό το στιγμιότυπο. Δοκιμάστε ξανά.',
  openStagedFailed: 'Δεν μπορέσαμε να ανοίξουμε αυτή την εισαγωγή σε προετοιμασία.',
  applyUnconfirmed:
    'Δεν μπορέσαμε να επιβεβαιώσουμε αν εφαρμόστηκε η εισαγωγή. Ελέγξτε τις Σελίδες πριν δοκιμάσετε ξανά.',
  applyFailed: 'Δεν μπορέσαμε να εφαρμόσουμε αυτή την εισαγωγή.',
  importHeading: 'Εισαγωγή σελίδων από το αποθετήριο',
  backToPages: 'Πίσω στις σελίδες',
  importLead:
    'Δημιουργήστε ένα στιγμιότυπο με {command} και επιλέξτε το αρχείο. Θα δείτε κάθε έγγραφο και τι θα άλλαζε πριν αποθηκευτεί οτιδήποτε.',
  snapshotFileLabel: 'Αρχείο στιγμιότυπου γνώσης',
  readingSnapshot: 'Ανάγνωση στιγμιότυπου…',
  openingStaged: 'Άνοιγμα εισαγωγής σε προετοιμασία…',
  chooseSnapshot: 'Επιλογή αρχείου στιγμιότυπου',
  factOrigin: 'Προέλευση',
  factContents: 'Περιεχόμενα',
  importOnlyListed: 'Εισάγονται μόνο τα έγγραφα που αναφέρονται εδώ.',
  importRepositoryAuthoritative:
    'Το αποθετήριο παραμένει η έγκυρη πηγή· τα έγγραφα με αλλαγές γίνονται προτάσεις για έλεγχο.',
  overviewReviewChanges: 'Έλεγχος αλλαγών',
  overviewConnectAgents: 'Σύνδεση εξωτερικών agents',
  overviewEyebrow: 'Μια κοινή κατανόηση',
  overviewTitle: '{company}, σε πλαίσιο.',
  overviewLeadFallback:
    'Η γνώση της εταιρείας σας ξεκινά από το πλαίσιο που μοιράζεστε. Χτίστε μαζί μια κατανόηση της επιχείρησής σας.',
  overviewBody:
    'Το πλαίσιο της εταιρείας και το υλικό πηγών δίνουν στο Poneva ένα σημείο εκκίνησης — όχι όλα όσα υπάρχουν να ξέρει κανείς για την {company}. Συνεχίστε να χτίζετε αυτή την κατανόηση καθώς εξελίσσεται η επιχείρησή σας.',
  overviewAskPrompt: 'Τι γνωρίζεις για την εταιρεία μας και τι θα ήταν χρήσιμο να προστεθεί;',
  overviewAsk: 'Ερώτηση για την {company}',
  overviewAddSources: 'Προσθήκη πηγών',
  contextEyebrow: 'Τι δίνει πλαίσιο στις απαντήσεις',
  contextTitle: 'Η επιχείρηση πίσω από την ερώτηση.',
  contextBody:
    'Οι πηγές από ιστότοπους εξηγούν τη δημόσια εικόνα της επιχείρησης. Οι σημειώσεις της εταιρείας προσθέτουν την ορολογία, τις προτεραιότητες και τον τρόπο εργασίας σας.',
  contextPrompt:
    'Βοήθησέ με να ξεκαθαρίσω τις προτεραιότητες και τις προτιμήσεις εργασίας της εταιρείας που πρέπει να θυμόμαστε.',
  contextAction: 'Οικοδόμηση της κατανόησής μας',
  learnEyebrow: 'Χώρος για μάθηση',
  learnTitle: 'Ξεκινήστε με ό,τι έχει σημασία στη συνέχεια.',
  learnBody:
    'Φέρτε υλικό πηγών ή ξεκαθαρίστε πώς λειτουργεί η εταιρεία σας. Το Poneva μπορεί να προτείνει μόνιμες αλλαγές για να τις ελέγξετε.',
  learnPrompt:
    'Με βάση την υπάρχουσα γνώση της εταιρείας μας, ποιες σημαντικές πληροφορίες λείπουν για τη δουλειά που θέλουμε να κάνουμε;',
  learnAction: 'Συζήτηση για το τι θα ήταν χρήσιμο',
  canvasEmptyTitle: 'Λίγο πλαίσιο κάνει μεγάλη διαφορά.',
  canvasEmptyBody:
    'Το προφίλ της εταιρείας σας είναι το σημείο εκκίνησης. Προσθέστε υλικό πηγών και ελεγμένες σημειώσεις για να βοηθήσετε το Poneva να κατανοήσει τη δουλειά σας.',
  pageEyebrow: 'Χώρος εργασίας της {company}',
  pageTitle: 'Γνώση της εταιρείας',
  pageDescription: 'Οι πηγές και η κατανόηση πίσω από τη δουλειά του Poneva.',
  tabOverview: 'Επισκόπηση',
  tabPages: 'Σελίδες',
  tabSources: 'Πηγές',
  tabReview: 'Για έλεγχο',
  proposalApproved: 'Εγκεκριμένο πλαίσιο εταιρείας',
  proposalDismissed: 'Πρόταση που απορρίφθηκε',
  proposalRemoval: 'Προτεινόμενη αφαίρεση',
  proposalCorrection: 'Προτεινόμενη διόρθωση',
  proposalContext: 'Προτεινόμενο πλαίσιο εταιρείας',
  proposalCurrent: 'Τρέχουσα κατανόηση',
  proposalFactGone:
    'Το αποθηκευμένο στοιχείο δεν είναι πλέον διαθέσιμο. Ανανεώστε τη γνώση της εταιρείας πριν ελέγξετε αυτή την αφαίρεση.',
  proposalReviewFallback: 'Ελέγξτε το προτεινόμενο πλαίσιο εταιρείας.',
  proposalNotSaved: 'Δεν έχει αποθηκευτεί ακόμη. Οι αρχικές πηγές παραμένουν αμετάβλητες.',
  proposalWaiting: 'Σε αναμονή ελέγχου · ένας υπεύθυνος δημοσίευσης αποφασίζει στα Εισερχόμενά του',
  proposalSaving: 'Αποθήκευση…',
  proposalApproveRemoval: 'Έγκριση αφαίρεσης',
  proposalApproveClarification: 'Έγκριση διευκρίνισης',
  factLabel: 'Στοιχείο εταιρείας',
  factEyebrow: 'Στοιχείο · Όλοι στην {company}',
  factSuggestCorrection: 'Πρόταση διόρθωσης',
  factAskPrompt:
    'Βοήθησέ με να κατανοήσω ή να διευκρινίσω αυτό το αποθηκευμένο πλαίσιο εταιρείας: «{content}»',
  factAsk: 'Ερώτηση γι’ αυτό',
  companyContextHeading: 'Πλαίσιο εταιρείας',
  companyContextPrompt:
    'Θέλω να διευκρινίσω τη γνώση της εταιρείας μας. Βοήθησέ με να ελέγξω τι γνωρίζουμε και να προτείνω μια ενημέρωση.',
  companyContextEmpty:
    'Δεν υπάρχουν ακόμη εγκεκριμένες σημειώσεις. Ξεκινήστε μια συνομιλία για την εταιρεία σας ή προσθέστε υλικό πηγών παρακάτω.',
  refineInChat: 'Βελτίωση στη συνομιλία',
  reviewPanelLabel: 'Αλλαγές γνώσης για έλεγχο',
  suggestedUpdatesHeading: 'Προτεινόμενες ενημερώσεις',
  suggestedUpdatesIntro:
    'Προτάσεις από τις συνομιλίες σας. Εσείς αποφασίζετε τι γίνεται μόνιμο μέρος της γνώσης της εταιρείας σας.',
  reviewEmptyTitle: 'Τίποτα δεν περιμένει τον έλεγχό σας.',
  reviewEmptyBody:
    'Όταν το Poneva προτείνει μια αλλαγή στη γνώση της εταιρείας σας, θα τη βρείτε εδώ. Οι μόνιμες αλλαγές χρειάζονται πάντα την έγκρισή σας.',
  reviewEmptyPrompt:
    'Βοήθησέ με να ελέγξω τη γνώση της εταιρείας μας και πρότεινε τι θα ήταν χρήσιμο να διευκρινίσουμε στη συνέχεια.',
  inclusionPendingApproval: 'Η αλλαγή συμπερίληψης στη γνώση στάλθηκε για έγκριση.',
  sourcesFileIncluded: 'Το αρχείο συμπεριλήφθηκε στην αναζήτηση γνώσης για το τρέχον κοινό του.',
  sourcesAddFailed: 'Δεν ήταν δυνατή η προσθήκη αυτής της πηγής.',
  sourcesHeading: 'Το υλικό πίσω από τις απαντήσεις.',
  sourcesIntro:
    'Το Poneva αναζητά σε όλο το υλικό πηγών, όχι μόνο στην επισκόπηση. Διατηρήστε τα πρωτότυπα, δείτε τι είναι έτοιμο και επιλέξτε τι διαμορφώνει τις απαντήσεις σας.',
  addSourceHeading: 'Προσθέστε υλικό από την εταιρεία σας',
  addSourceIntro:
    'Οι πηγές που ανεβάζετε παραμένουν ιδιωτικές στη Βιβλιοθήκη σας και διαμορφώνουν μόνο τις δικές σας απαντήσεις. Επιλέξτε Κοινοποίηση όταν είστε έτοιμοι να τις διαθέσετε στους συναδέλφους σας.',
  uploadSource: 'Ανέβασμα πηγής',
  addSourcePrompt:
    'Βοήθησέ με να προσθέσω μια δήλωση της εταιρείας ως κοινόχρηστη εσωτερική πηγή. Ρώτα με τι θέλω να καταγράψω και μην επινοείς περιεχόμενο. Οι μόνιμες αλλαγές στην κατανόηση της εταιρείας χρειάζονται και πάλι την έγκρισή μου.',
  addThroughChat: 'Προσθήκη μέσω συνομιλίας',
  addingSource: 'Προσθήκη…',
  addToKnowledge: 'Προσθήκη στη γνώση',
  uploadFormats: 'TXT, Markdown, CSV και JSON · Έως 5 MB ανά αρχείο',
  sourceExcluded: 'Εξαιρείται από τις απαντήσεις',
  sourcePreparationFailed: 'Η προετοιμασία απέτυχε',
  sourcePreparing: 'Προετοιμασία για αναζήτηση',
  sourceWaiting: 'Σε αναμονή προετοιμασίας',
  sourceReadinessUnknown: 'Η ετοιμότητα δεν είναι διαθέσιμη',
  sourceRetryQueued: 'Η προετοιμασία μπήκε σε ουρά. Η ετοιμότητα θα ενημερωθεί όταν ολοκληρωθεί.',
  sourceIncludedNotice: 'Η πηγή συμπεριλήφθηκε. Το Poneva θα την προετοιμάσει για αναζήτηση.',
  sourceExcludedNotice: 'Εξαιρέθηκε από τις απαντήσεις. Η αρχική πηγή διατηρείται.',
  sourceUpdateFailed: 'Δεν ήταν δυνατή η ενημέρωση αυτής της πηγής.',
  sourceOriginalMaterial: 'Αρχικό υλικό πηγής',
  sourceDiscuss: 'Συζήτηση στη συνομιλία',
  sourceDiscussPrompt: 'Βοήθησέ με να κατανοήσω ή να διευκρινίσω το «{title}».',
  sourceExclude: 'Εξαίρεση από τις απαντήσεις',
  sourceInclude: 'Συμπερίληψη στις απαντήσεις',
  sourcesLoadFailed: 'Δεν μπορέσαμε να φορτώσουμε τις πηγές σας.',
  sourceLibraryLabel: 'Βιβλιοθήκη πηγών της εταιρείας',
  sourceListCaption: 'Αρχικές πηγές · συμπεριλαμβανόμενες και εξαιρούμενες',
  sourceSearchLabel: 'Αναζήτηση στις πηγές της εταιρείας',
  sourceSearchPlaceholder: 'Αναζητήστε στις πηγές σας…',
  sourcesFinding: 'Εύρεση των πηγών σας…',
  sourcePagesLabel: 'Σελίδες πηγών',
  sourceRange: '{from}–{to} από {count}',
  sourceCount: 'one:πηγή|other:πηγές',
  sourcePrevious: 'Προηγούμενη',
  sourceNext: 'Επόμενη',
  sourceNoMatchTitle: 'Δεν υπάρχουν πηγές που να ταιριάζουν.',
  sourceNoMatchBody: 'Δοκιμάστε διαφορετική φράση ή όνομα πηγής.',
  sourceEmptyTitle: 'Δώστε στις ερωτήσεις σας ένα πιο στέρεο σημείο εκκίνησης.',
  sourceEmptyBody:
    'Προσθέστε έγγραφα της εταιρείας, δεδομένα προϊόντων ή σημειώσεις εργασίας. Το Poneva μπορεί να χρησιμοποιεί όλο το υλικό πηγών σε συνομιλίες και Skills.',
  indexCheckFailed: 'Δεν μπορέσαμε να ελέγξουμε την προετοιμασία των πηγών.',
  indexRetryQueued:
    'Οι καταχωρίσεις γνώσης που απέτυχαν μπήκαν σε ουρά για προετοιμασία. Το υλικό πηγών σας παραμένει αμετάβλητο.',
  indexQueueFailed: 'Δεν μπορέσαμε να βάλουμε την προετοιμασία σε ουρά. Δοκιμάστε ξανά.',
  indexPreparing: 'Προετοιμασία νέας γνώσης για τις συνομιλίες σας…',
  indexAttention: 'Μέρος της γνώσης χρειάζεται προσοχή.',
  queuing: 'Προσθήκη σε ουρά…',
  retryPreparation: 'Επανάληψη προετοιμασίας',
  sourceKindStatement: 'Δήλωση της εταιρείας',
  sourceKindWebsite: 'Ιστότοπος',
  sourceKindDocument: 'Έγγραφο',
  factAnswers: 'one:απάντηση|other:απαντήσεις',
  factUsedThisWeek: 'Χρησιμοποιήθηκε σε {answers} αυτήν την εβδομάδα',
  factLastUsed: 'τελευταία χρήση: {when}',
  factToday: 'σήμερα',
  factYesterday: 'χθες',
  factImpact:
    'Η αλλαγή επηρεάζει ένα στοιχείο που χρησιμοποιήθηκε σε {answers} αυτήν την εβδομάδα.',
  factCorrectionAbout: 'Σχετικά με αυτό το στοιχείο της εταιρείας: «{content}» ({link})',
  factCorrectionOutdated: 'Αυτό δεν ισχύει πλέον:',
  sourceCanvasRecorded: 'Καταγεγραμμένο υλικό πηγής',
  sourceCanvasNotIncluded:
    'Δεν περιλαμβάνεται στη γνώση της εταιρείας. Το πρωτότυπο διατηρείται για αναφορά και μπορεί ακόμη να χρησιμοποιηθεί σε μια συγκεκριμένη συνομιλία.',
  sourceCanvasOpenOriginal: 'Άνοιγμα αρχικής πηγής',
  sourceCanvasUnavailable: 'Το περιεχόμενο της πηγής δεν είναι διαθέσιμο.',
  sourceCanvasDiscussPrompt: 'Βοήθησέ με να κατανοήσω ή να διευκρινίσω το «{title}».',
  sourceCanvasDiscuss: 'Συζήτηση αυτής της πηγής',
  sourceCanvasCorrectionNote:
    'Μια διόρθωση γίνεται προτεινόμενο πλαίσιο εταιρείας. Η καταγεγραμμένη πηγή παραμένει αμετάβλητη.',
  contextCanvasEyebrow: 'Διαθέσιμο πλαίσιο εταιρείας',
  contextCanvasTitle: 'Η γνώση πίσω από αυτή τη συνομιλία.',
  contextCanvasBody:
    'Εγκεκριμένη κατανόηση και το υλικό πηγών που έχει προσθέσει η εταιρεία σας. Διαθέσιμα στη συνομιλία και στα Skills.',
  contextCanvasOpen: 'Άνοιγμα Γνώσης',
};

export default el;
